import { Button } from "@mui/material";

interface DateRangeCalendarFooterProps {
  disabled: boolean;
  onApply: () => void;
  onReset: () => void;
  isResetDisabled: boolean;
}

const DateRangeCalendarFooter = ({
  disabled,
  onApply,
  onReset,
  isResetDisabled,
}: DateRangeCalendarFooterProps) => (
  <footer className="flex justify-end gap-3 p-4 w-full">
    <Button
      variant="text"
      disabled={isResetDisabled}
      onClick={onReset}
      className="text-text-secondary"
      size="small"
    >
      Reset
    </Button>
    <Button variant="contained" disabled={disabled} onClick={onApply} size="small">
      Apply
    </Button>
  </footer>
);

export default DateRangeCalendarFooter;
